/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Alert, Card } from '@mantine/core'
import { useRouteError } from 'react-router'
import { useIntl } from 'react-intl'

function RouteErrorBoundary () {
  const error = useRouteError()
  const intl = useIntl()
  return (
    <Card p={0}>
      <Alert
        color="red"
        title={intl.formatMessage({
          id: 'error',
          defaultMessage: 'Erreur'
        })}
      >
        {error instanceof Error
          ? error.message
          : null}
      </Alert>
    </Card>
  )
}

export default RouteErrorBoundary
